import styled from 'styled-components';
import ContentWrapper from '../../components/ContentWrapper';

export const PageContent = styled(ContentWrapper)`
  margin-top: 48px;
  margin-bottom: 48px;
`;
